import React, { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import { RightOutlined } from "@ant-design/icons";
import {

    Row,
    Col,

    Button,

    Form,
    Input,

    Select,

    Radio,

    Space,
    Divider,
    Spin,


} from "antd";


import coachService from "../../../api/coach.service";





import { EDIT_MODE, SUCCESS_STATUS } from "../../../utility/Constants";

import CustomMessage from "../../common/CustomMessage";
import { addCoach } from "../../../store/coachSlice";
import commonUtility from "../../../utility/Utils";
import CoachDetailEntryComponent from "./CoachDetailEntryComponent";
const { Option } = Select;
const { TextArea } = Input;



const CoachEntry = ({ data , onDrawerClose}) => {
    // console.log(data)

    const dispatch = useDispatch();

    const [isLoaderEnable, setIsLoaderEnable] = useState(false);
    const [isFormResponse, setIsFormResponse] = useState(false);
    const [formResponseMessage, setFormResponseMessage] = useState("");
    const [formResponseStatus, setFormResponseStatus] = useState("");
    // const [totalfee, setTotalFee] = useState(0);
    // const [feesInputs, setFeesInputs] = useState({
    //     coach_amount: data.coach_amount,
    //     bta_amonut: data.bta_amonut
    // });
    const [coachDetailList, setCoachDetailList] = useState([]);
    const [designationList, setDesignationList] = useState([]);



    const [formDefaultValues, setFormDefaultValues] = useState({
        coach_id: data.coach_id,
        coach_name: data.coach_name,
        mobile: data.mobile,
        whatsapp: data.whatsapp,
        qwer: data.whatsapp,
        address: data.address,
      //  coach_amount: data.coach_amount,
       // bta_amonut: data.bta_amonut,
      //  coaching_fee: data.coaching_fee,
      //  is_active: data.is_active,
        mode: data.mode,
        coach_detail:data.coach_detail,
        designation:data.designation,
        coach_work_status:data.coach_work_status,
        certification:data.certification,
    });

    const [mode, setMode] = useState(data.mode);


    const [form] = Form.useForm();


    const addCoachDetail = () => {
        
        const playing_ratio_id = form.getFieldValue('playing_ratio_id');
        const rate_for = form.getFieldValue('rate_for');
        const ratio_name = form.getFieldValue('ratio_name');
        const time_tag = form.getFieldValue('time_tag');
        const coach_amount = form.getFieldValue('coach_amount');
        const bta_amount = form.getFieldValue('bta_amount');
        const coaching_fee = form.getFieldValue('coaching_fee_input');

        if (commonUtility.sanitizeObject(playing_ratio_id) && commonUtility.sanitizeObject(time_tag) && commonUtility.sanitizeValue(coach_amount) > 0) {
          setCoachDetailList([...coachDetailList, {
            rate_details_id:0,
            playing_ratio_id: playing_ratio_id,
            rate_for: rate_for,
            ratio_name: ratio_name,
            time_tag: time_tag,
            coach_amount: parseFloat(coach_amount),
            bta_amount: parseFloat(bta_amount),
            coaching_fee: parseFloat(coaching_fee),
          }]);

            // Detail Box Empty
            form.setFieldsValue({
                playing_ratio_id: "",
                rate_for: "",
                ratio_name: "",
                time_tag: "",
                coach_amount: "",
                bta_amount: "",
                coaching_fee_input: "",
            });
        }
    }

    const removeDetail = (index) => {
        const list = [...coachDetailList];
        list.splice(index, 1);
        setCoachDetailList(list);
    }


    const onCoachSave = async (values) => {
        

        if(values.coach_detail.length > 0){
            setIsLoaderEnable(true)
            const data = { formdata: values };
            console.log(values);
            // return false;
            const response = coachService.save(data).then((resdata) => {
    
                setIsFormResponse(true);
                setFormResponseStatus(resdata.response_status);
                setFormResponseMessage(resdata.response_msg);
                const x = {
                    coach_id:commonUtility.randomID(),
                    coach_name:values.coach_name
                }
                dispatch(addCoach(x))
                setIsLoaderEnable(false)
            });
        }else{
            commonUtility.openNotificationWithType("error","bottomRight","Error","To save this data, please provide at least one coach detail.");
            setIsLoaderEnable(false)
        }


        


    };


    // const handleChangeEvent = (e) => {
    //     const val = e.target.value != "" && e.target.value > 0 ? e.target.value : 0;
    //     setFeesInputs({ ...feesInputs, [e.target.id]: val });

    // }

    // useEffect(() => {
    //     setTotalFee(parseInt(feesInputs.coach_amount) + parseInt(feesInputs.bta_amonut))
    // }, [feesInputs])

    // useEffect(() => {
    //     form.setFieldsValue({ coaching_fee_input : totalfee })
    // }, [totalfee]);






    const hideResponseMessage = () => {
        setIsFormResponse(false);
        if(mode == "ADD") {
            form.resetFields()

            form.setFieldsValue({
                coach_id: 0,
                is_active: 'Y',
                mode: data.mode
            })
        }
    }


    useEffect(() => {

        setCoachDetailList(formDefaultValues.coach_detail);
        
        mode == EDIT_MODE ?

            form.setFieldsValue({
                coach_id: formDefaultValues.coach_id,
                coach_name: formDefaultValues.coach_name,
                mobile: formDefaultValues.mobile,
                whatsapp: formDefaultValues.whatsapp,
                address: formDefaultValues.address,
                // coach_amount: 0,
                // bta_amonut: 0,
                // coaching_fee:0,
                //is_active: formDefaultValues.is_active,
                mode: formDefaultValues.mode,
                coach_detail:formDefaultValues.coach_detail,
                designation:formDefaultValues.designation,
                coach_work_status:formDefaultValues.coach_work_status,
                certification:formDefaultValues.certification,
            })
            
            :
            form.setFieldsValue({
                coach_id: 0,
                coach_name: '',
                mobile: '',
                whatsapp: '',
                address: '',
                //coach_amount: '',
                //bta_amonut: "",
                //coaching_fee: '',
                //is_active: 'Y',
                mode: data.mode,
                coach_detail:[],
                designation:'',
                coach_work_status:'',
                certification:'',
            });


        //form.setFieldsValue(formDefaultValues)

    }, [form]);



    useEffect(() => {
        coachService.designationList().then((res) => {
            console.log(res);
            if (res.data.response_status === SUCCESS_STATUS) {
                setDesignationList(res.data.response_data);
            }

        });
    }, []);



    return (
        <div>
            <div className="form-input-style">

                <Row className="" style={{ background: "transparent" }}>
                    <Col className="" xs={24} xl={24}>
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={onCoachSave}
                            autoComplete="off"
                            initialValues={formDefaultValues}
                        >

                            {/* <Row gutter={20}>
                            <Col className="gutter-row" xs={24} xl={24}>
                                <h5>Note: * fields are required</h5>
                            </Col>
                        </Row> */}
                            <Row gutter={20}>
                                <Col className="gutter-row" xs={24} xl={12}>
                                    <Form.Item name="coach_name" label="Name" rules={[
                                        {
                                            required: true,
                                            message: 'Name is required',
                                        },
                                    ]}>
                                        <Input placeholder="" />
                                    </Form.Item>
                                    <Form.Item name="coach_id" label="coach_id" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                    <Form.Item name="mode" label="mode" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                </Col>


                                <Col xs={24} xl={12}>
                                    <Form.Item name="mobile" label="Mobile" rules={[
                                        {
                                            required: false,
                                            message: 'Mobile No is required',
                                        },
                                     ]}>
                                        <Input placeholder="" maxLength={10}  />
                                    </Form.Item>
                                </Col>


                                <Col xs={24} xl={12}>
                                    <Form.Item name="whatsapp" label="Whatsapp No." >
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={12}>
                                    <Form.Item name="designation" label="Designation">
                                        <Select className="text-left" defaultValue="Select">
                                            <Option value="">Select</Option>
                                            {
                                                designationList.length > 0 ?
                                                    designationList.map(designation_list => (
                                                        <Option key={designation_list.designation_id} value={designation_list.designation_id}>{designation_list.designation_name}</Option>
                                                    ))
                                                    : ''
                                            }
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>

                               

                            <Row gutter={20}>

                                <Col xs={24} xl={24}>
                                    <Form.Item name="address" label="Address" >
                                        <TextArea rows={1} />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={12}>
                                    <Form.Item name="coach_work_status" label="Status">
                                        <Select className="text-left" defaultValue="Select">
                                            <Option value="">Select</Option>
                                            <Option value="PART TIME">Part Time</Option>
                                            <Option value="FULL TIME">Full Time</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>


                                <Col xs={24} xl={12}>
                                    <Form.Item name="certification" label="Certification" >
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>



                                {/* <Col xs={24} xl={12}>
                                    <Form.Item name="coach_amount" label="Coach Amount" 
                                    rules={[
                                        {
                                          pattern: /^[\d]{0,9}$/,
                                          message: "Only number allowed",
                                        },
                                      ]}
                                    onChange={handleChangeEvent} >
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={12}>
                                    <Form.Item name="bta_amonut" label="BTA Amount" onChange={handleChangeEvent} >
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={12}>
                                    <Form.Item name="coaching_fee" label="Coaching Fee">
                                        <Input placeholder="" readOnly={true} />
                                    </Form.Item>
                                </Col>




                                <Col xs={24} xl={12}>
                                    <Form.Item name="is_active" label="Active">
                                        <Radio.Group
                                            defaultValue="Y"
                                            style={{ width: "100%" }}
                                            optionType="button"
                                            buttonStyle="solid"
                                        >
                                            <Radio.Button value="Y">Yes</Radio.Button>
                                            <Radio.Button value="N">No</Radio.Button>
                                        </Radio.Group>
                                    </Form.Item>
                                </Col>


                                <Col xs={24} xl={12}>
                                    <Form.Item name="" label=" ">
                                        <Space>

                                            <Button className="custom-button-green" htmlType="submit">
                                                Save <RightOutlined />
                                            </Button>
                                        </Space>
                                    </Form.Item>
                                </Col> */}


                            </Row>

                        <Divider />
                        <h4>Add Coach Rate detail </h4>
                       
                        <CoachDetailEntryComponent 
                            coachForm={form}
                            detailInputKey="coach_detail" 
                            addCoachDetail={addCoachDetail} 
                            coachDetailList={coachDetailList} 
                            setCoachDetailList={setCoachDetailList} 
                            removeDetail={removeDetail}
                        /> 
                            

                            <Col xs={24} xl={12}>
                                    <Form.Item name="" label=" ">
                                        <Space>
                                            {
                                                isLoaderEnable ? <Spin /> : <>
                                                    <Button className="custom-button-green" htmlType="submit">
                                                        Save <RightOutlined />
                                                    </Button>
                                                </>
                                            }
                                            
                                        </Space>
                                    </Form.Item>
                                </Col> 

                        </Form>



                    </Col>
                </Row>
                {
                    // isFormResponse ? <CustomMessage title={formResponseStatus} subtitle={formResponseMessage} action={hideResponseMessage} /> : ''
                    isFormResponse ? <CustomMessage title={formResponseStatus} subtitle={formResponseMessage} action={hideResponseMessage} onDrawerClose={onDrawerClose} mode={form.getFieldValue('mode')} /> : ''
                }




            </div>
        </div>
    );
};

export default CoachEntry;
